module.exports = __webpack_public_path__ + "media/images/site/152-01-4643aba25a35e8a5ed52ef36ef378c6e.svg";